/**
 * URL absolutas del sitio.
 *
 * La canonical y las etiquetas Open Graph exigen URL absolutas: un `/producto/x`
 * relativo no le sirve ni a Google ni a WhatsApp cuando alguien comparte el
 * enlace. Se arman todas desde `SITIO.urlBase` para que apunten al dominio real
 * y no al `localhost` desde el que se compilo.
 */
import { SITIO } from '../configuracion/sitio';

function sinBarraFinal(texto: string): string {
  return texto.endsWith('/') && texto.length > 1 ? texto.slice(0, -1) : texto;
}

/**
 * Convierte una ruta interna en la URL absoluta que se publica.
 *
 * La portada conserva su barra final (`https://.../`), que es la forma
 * canonica de una raiz; el resto de las rutas se publica sin ella, para que
 * `/categoria/sierras` y `/categoria/sierras/` no compitan como dos paginas.
 */
export function urlAbsoluta(ruta: string): string {
  if (ruta.startsWith('http://') || ruta.startsWith('https://')) return ruta;

  const base = sinBarraFinal(SITIO.urlBase);
  const camino = ruta.startsWith('/') ? ruta : `/${ruta}`;

  if (camino === '/') return `${base}/`;
  return sinBarraFinal(`${base}${camino}`);
}
